export const convertPlanToInformationItem = ({ planContent }) =>
  planContent.content.features.reduce(
    (acc, current) => {
      acc[current.key] = current.value;
      return acc;
    },
    { id: planContent.uuid }
  );
